import React from "react";

export default function WaitingIcon() {
  return <div>⏳</div>;
}
